import type { RootState } from '../store';

export const getHistoricalData = (state: RootState) => state.historicalData;
